import { render, staticRenderFns } from "./LawTradeFairList.vue?vue&type=template&id=1c68ddd8&"
import script from "./LawTradeFairList.vue?vue&type=script&lang=js&"
export * from "./LawTradeFairList.vue?vue&type=script&lang=js&"
import style0 from "./LawTradeFairList.vue?vue&type=style&index=0&id=1c68ddd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports